import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const JSTSOFPA_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/jstsofpa/logo.png",
        alt: "J. Snyder Therapeutic Services of Pennsylvania Logo",
        style: { width: "300px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 29,
  state: "PA",
  departmentIds: [134, 139, 151],
};
